import React, { useRef, useImperativeHandle, Ref, ChangeEvent, forwardRef } from 'react';
import './FileUpload.css';

// Define the interface for the functions we want to expose via the ref
export interface FileUploadRef {
  openFileDialog: () => void;
}

interface FileUploadProps {
  onFileSelect: (files: FileList) => void;
  allowedFileTypes: string[];
  maxFileSizeMB?: number;
}

const FileUpload = forwardRef((props: FileUploadProps, ref: Ref<FileUploadRef>) => {
  const { onFileSelect, allowedFileTypes, maxFileSizeMB } = props;
  const fileInputRef = useRef<HTMLInputElement>(null);

  // Expose the openFileDialog function to the parent component via the ref
  useImperativeHandle(ref, () => ({
    openFileDialog() {
      if (fileInputRef.current) {
        fileInputRef.current.click();
      }
    },
  }));

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && onFileSelect) {
      onFileSelect(event.target.files);
    }
  };

  return (
    <input
      type="file"
      ref={fileInputRef}
      onChange={handleFileChange}
      multiple
      accept={allowedFileTypes.join(',')}
      style={{ display: 'none' }}
    />
  );
});

export default FileUpload;
